import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3ebff49b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "artical-card bg-white rounded-4 shadow p-lg-5 pt-lg-3" }
const _hoisted_2 = { class: "header-artical cursor-pointer border-bottom" }
const _hoisted_3 = { class: "d-flex flex-lg-row flex-column justify-content-between align-items-lg-center align-items-start mb-2 mb-lg-0" }
const _hoisted_4 = { class: "align-items-center" }
const _hoisted_5 = { class: "fs-7 d-flex mb-1rem" }
const _hoisted_6 = { class: "fw-bold mb-1rem fs-9 ps-lg-0 text-break block-line artical-title" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = {
  class: "d-flex justify-content-end mt-1rem",
  style: {"color":"#00b140"}
}
const _hoisted_9 = { class: "mx-2" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-thumbs-up fs-5 mr-2rem" }, null, -1))

import { PostType } from '@/store/modules/post'
import { ChangeTime } from '@/constants/datepicker'
import DOMPurify from 'dompurify'
import { keepTextOnlySanitizeConfig } from '@/constants/validate'


export default /*#__PURE__*/_defineComponent({
  props: {
  item: {
    type: Object as PostType,
  },
},
  setup(__props) {



const removeHtmlTags = (content) => {
  if (!content) return ''

  // Convert line/segment break tags to \n
  // Convert <br> or <br/> to \n, Replace the closing </p> tag with \n, Remove opening <p> tag
  const formattedContent = content
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/<\/p>/gi, '\n')
    .replace(/<p[^>]*>/gi, '')

  const cleanText = DOMPurify.sanitize(formattedContent, keepTextOnlySanitizeConfig)

  // Replace all consecutive empty lines (one or more \n) with a single \n
  return cleanText.replace(/\n+/g, '\n').trim()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(__props.item?.published_date ? _unref(ChangeTime)(__props.item?.published_date) : '-'), 1),
          _createElementVNode("h3", _hoisted_6, _toDisplayString(__props.item.title), 1)
        ])
      ])
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("div", {
        class: "mt-3 text-break block-line artical-content",
        innerHTML: removeHtmlTags(__props.item?.content)
      }, null, 8, _hoisted_7)
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("span", _hoisted_9, _toDisplayString(__props.item?.like_count ? __props.item?.like_count : 0), 1),
      _hoisted_10
    ])
  ]))
}
}

})